import { memo } from 'react'
import { Box, Divider, Grid, Paper, Typography } from '@mui/material'
import Positions from '../../assets/icons/Positions'
import TradingAccountSelector from '../tradingAccountStatus/TradingAccountSelector'
import GenericTabsSmall from '../genericTabs/GenericTabsSmall'
import { PositionNavButtons, navItems } from '../postionsWidget'
import type { Position } from '../../proto/generated/position'
import PositionsTotalPnL from './PositionsTotalPnL'

export type PositionsSidebarHeaderProps = {
    positions: Position[]
    viewType: PositionNavButtons
    onViewTypeChange: (viewType: PositionNavButtons) => void
}

const PositionsSidebarHeader: React.FC<PositionsSidebarHeaderProps> = ({
    positions,
    viewType,
    onViewTypeChange,
}) => (
    <Paper sx={{ position: 'sticky', top: 0, zIndex: 10, borderRadius: 0, width: '100%' }}>
        <Grid container px={'8px'} py={0} justifyContent={'space-between'} alignItems={'center'}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Positions sx={{ color: (theme) => theme.palette.text.secondary }} />
                <Typography variant={'body1'}>Positions</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <PositionsTotalPnL positions={positions} />
                <TradingAccountSelector compact />
            </Box>
        </Grid>
        <Divider style={{ width: '100%' }} />
        {positions.length > 0 && (
            <Grid container px={'8px'} py={1} alignItems={'center'} justifyContent={'flex-end'}>
                <GenericTabsSmall<PositionNavButtons>
                    items={navItems}
                    onChange={(val) => {
                        if (val) onViewTypeChange(val)
                    }}
                    value={viewType}
                    tabProps={{ sx: { minWidth: 50, fontSize: '12px' } }}
                />
            </Grid>
        )}
    </Paper>
)

export default memo(
    PositionsSidebarHeader,
    (prev, next) =>
        prev.positions === next.positions &&
        prev.viewType === next.viewType &&
        prev.onViewTypeChange === next.onViewTypeChange
)
